import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PcbMappingRoutingModule} from './pcb-mapping-routing.module';
import {PcbMappingComponent} from './pcb-mapping.component';
import {AddPcbMappingComponent} from './add-pcb-mapping/add-pcb-mapping.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [PcbMappingComponent, AddPcbMappingComponent],
    imports: [
        CommonModule,
        PcbMappingRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [PcbMappingComponent, AddPcbMappingComponent]
})
export class PcbMappingModule {
}
